import Synch from './Synch';
export default Synch;
